import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import $ from "jquery";
import './EventPlannedNavbar.css';
import { useLiveEvents } from '../../views/event-planned/liveUtils';

const EventPlannedNavbar = ({ isEventPlanned = true }) => {
    const location = useLocation();
    const [isHidden, setIsHidden] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    // Force visible on route change in case Bootstrap collapse events get it stuck
    useEffect(() => {
        setIsHidden(false);
    }, [location.pathname]);
    
    useEffect(() => {
        const target = $('#navbarSupportedContent');
        const handleShow = () => {
            // Only hide the navbar on mobile when the menu opens
            if (window.innerWidth < 992) {
                setIsHidden(true);
            }
        };
        const handleHide = () => setIsHidden(false);

        if (target.length) {
            target.on('show.bs.collapse', handleShow);
            target.on('hide.bs.collapse', handleHide);
        }
        return () => {
            if (target.length) {
                target.off('show.bs.collapse', handleShow);
                target.off('hide.bs.collapse', handleHide);
            }
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Helper function to check if link is active
    const isActive = (path) => location.pathname === path ? 'active' : '';

    const { isLive, currentLiveEvent } = useLiveEvents();

    return (
        <div className="ep-navbar-container" style={{ display: (isHidden || !isEventPlanned) ? 'none' : 'flex' }}>
            <div className={`ep-navbar-pill ${isScrolled ? 'scrolled' : ''}`}>
                <div className="ep-navbar-brand">
                    <Link to="/organizaciones-con-proposito">
                        <FormattedMessage id="navEventPlanned" defaultMessage="Organizaciones con Propósito" />
                    </Link>
                </div>
                <div className="ep-navbar-links">
                    <Link to="/organizaciones-con-proposito/agenda" className={`ep-navbar-link ${isActive('/organizaciones-con-proposito/agenda')}`}>
                        <FormattedMessage id="navEventPlannedAgenda" defaultMessage="Programa" />
                    </Link>
                    <Link to="/organizaciones-con-proposito/speakers" className={`ep-navbar-link ${isActive('/organizaciones-con-proposito/speakers')}`}>
                        <FormattedMessage id="navEventPlannedSpeakers" defaultMessage="Speakers" />
                    </Link>
                    <Link to="/organizaciones-con-proposito/live" className={`ep-navbar-link ${isActive('/organizaciones-con-proposito/live')}`}>
                        {isLive && <span style={{ marginRight: '5px', animation: 'pulse 2s infinite' }}>🔴</span>}
                        <FormattedMessage id="navEventPlannedLive" defaultMessage="Estamos En Vivo" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default EventPlannedNavbar;
